import React from 'react';
import { useSearchParams, useParams, Link } from 'react-router-dom';
import InfoIcon from '@mui/icons-material/Info';
import {
  Tabs, Tab, Tooltip, Typography
} from '@mui/material';
import BodyContainer from '@seccon/shared/ui/components/BodyContainer';
import TabContent from '@seccon/shared/ui/components/TabContent';
import Overview from './components/Overview';
import UpdateRecords from './components/UpdateRecords';
import useOverviewData from './hooks/useOverviewData';

const OVERVIEW = 'overview';

const UPDATE_RECORDS = 'updateRecords';

const TABS = [
  { id: OVERVIEW, label: 'overview', tooltip: 'This view presents a report of the entries from the uploaded document that were matched, need verification, or is missing.' },
  { id: UPDATE_RECORDS, label: 'Update Records', tooltip: 'This form is used to update personnel records that match the rows in the uploaded document.' }
];

const TAB_CONTENT = [
  { id: OVERVIEW, Content: Overview },
  { id: UPDATE_RECORDS, Content: UpdateRecords }
];

const styles = {
  pageHeader: {
    alignItems: 'left',
    display: 'flex'
  },
  tabContainer: {
    borderBottom: 1,
    borderColor: 'grey.400'
  }
};

const PersonnelComparisonTool = () => {
  const { id: sessionId } = useParams();

  const [searchParams] = useSearchParams();
  const activeTab = searchParams.get('tab') || 'overview';
  const facilityId = searchParams.get('facilityId') ?? '';

  const { isLoading, isError } = useOverviewData(sessionId);

  return (
    <BodyContainer>
      {!isError && !isLoading && (
        <>
          <Tabs
            aria-label='Personnel Comparison Tool'
            sx={styles.tabContainer}
            value={activeTab}
          >
            {TABS.map(({ id, label, tooltip }) => (
              <Tab
                aria-controls={`tabpanel-${ id }`}
                component={Link}
                id={`tab-${ id }`}
                key={id}
                label={(
                  <Typography sx={{ display: 'flex', alignItems: 'center' }}>
                    {label}
                    <Tooltip title={tooltip}>
                      <InfoIcon fontSize='small' sx={{ marginLeft: '4px' }} />
                    </Tooltip>
                  </Typography>
                )}
                to={`/personnelComparisonTool/${ sessionId }/index?tab=${ id }&facilityId=${ facilityId }`}
                value={id}
              />
            ))}
          </Tabs>

          {TAB_CONTENT.map(({ id, Content }) => (
            <TabContent
              Content={Content}
              id={id}
              key={id}
              visible={activeTab === id}
            />
          ))}
        </>
      )}
    </BodyContainer>
  );
};

export default PersonnelComparisonTool;
